export const sxConfig = {
  buttonDialogBox: {
    height: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: 'rgb(22, 163, 74)',
    backgroundColor: 'rgba(187, 247, 208, 0.3)',
    border: '2px solid rgb(22, 163, 74)',
    borderRadius: '12px',
    fontSize: '2rem',
    fontWeight: 700,
    cursor: 'pointer',
    userSelect: 'none',
  },

  buttonDialogTypography1: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1,
  },

  buttonDialogTypography2: {
    fontSize: '0.85rem',
    fontWeight: 500,
    lineHeight: 1.2,
  },

  descDialogContainer: {
    marginTop: '1rem',
  },

  descDialogButtonContainer: {
    textAlign: 'center',
    marginTop: '1rem',
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'center',
  },

  operationDialogIcon: {
    color: 'grey',
  },
};
